module.exports = __webpack_public_path__ + "rosacea_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_5_after.jpg
// module id = 985
// module chunks = 0